import { render, staticRenderFns } from "./ReplyToMessage.vue?vue&type=template&id=1c36fa48&"
import script from "./ReplyToMessage.vue?vue&type=script&lang=js&"
export * from "./ReplyToMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplyToMessage.vue?vue&type=style&index=0&id=1c36fa48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports